import React, { useState, useEffect, lazy, Suspense } from 'react';
import { Routes, Route, useNavigate, useLocation, Navigate } from 'react-router-dom';
import DashboardLayout from '../Layout/DashboardLayout';
import LoadingScreen from '../Common/LoadingScreen';
import { analyticsService } from '../../utils/analyticsService';

// Lazy-loaded page components for optimal bundle splitting and performance
const MiteinanderPage = lazy(() => import('./MiteinanderPage'));
const MarktplatzPage = lazy(() => import('./MarktplatzPage'));
const FreundePage = lazy(() => import('./FreundePage'));
const ChatPage = lazy(() => import('./ChatPage'));
const LocationPage = lazy(() => import('./LocationPage'));
const ProfilePage = lazy(() => import('./ProfilePage'));
const SettingsPage = lazy(() => import('./SettingsPage'));
const SecurityPoliciesPage = lazy(() => import('./SecurityPoliciesPage'));
const ForumPage = lazy(() => import('./ForumPage'));
const BlogPage = lazy(() => import('./BlogPage'));
const SearchPage = lazy(() => import('./SearchPage'));

const Dashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Extract current section from URL
  const getCurrentSection = () => {
    const path = location.pathname.split('/')[2];
    return path || 'miteinander';
  };

  const [currentSection, setCurrentSection] = useState(getCurrentSection());

  // Automatically track every section transition for privacy-first analytics
  useEffect(() => {
    const section = getCurrentSection();
    setCurrentSection(section);
    analyticsService.trackEvent('navigation', 'view_page', section);
  }, [location.pathname]);

  const handleSectionChange = (section) => {
    setCurrentSection(section);
    navigate(`/dashboard/${section}`);
  };

  return (
    <DashboardLayout 
      currentSection={currentSection} 
      onSectionChange={handleSectionChange}
    >
      <Suspense fallback={
        <LoadingScreen />
      }>
        <Routes>
          <Route path="/" element={<MiteinanderPage />} />
          <Route path="/miteinander" element={<MiteinanderPage />} />
          <Route path="/marktplatz" element={<MarktplatzPage />} />
          <Route path="/forum" element={<ForumPage />} />
          <Route path="/wissen" element={<BlogPage />} />
          <Route path="/freunde" element={<FreundePage />} />
          <Route path="/chat" element={<ChatPage />} />
          <Route path="/location" element={<LocationPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/security" element={<SecurityPoliciesPage />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="*" element={<Navigate to="/miteinander" replace />} />
        </Routes>
      </Suspense>
    </DashboardLayout>
  );
};

export default Dashboard;
